<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('offer.tag.tag') }}
                <template v-if="isLoaded && tag.name"> - {{ tag.name }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        :to="{ name: 'offers.tags.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('offer.tag.tagsList') }}</span>
                        <span class="hidden-xs">{{ $t('offer.tag.tagsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-if="isLoaded && !isError"
                        :to="{
                            name: 'offers.tags.edit',
                            params: { id: tagId },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('edit') }}</span>
                        <span class="hidden-xs">{{ $t('edit') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-edit"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body with-border clearfix"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <template v-else>
                            <div
                                v-if="isError || !tag.id"
                                class="box-body with-border clearfix"
                            >
                                <div class="row">
                                    <div class="col-xs-12">
                                        <p>
                                            {{ $t('messages.offer.tag.noTag', { id: tagId }) }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <template v-else>
                                <div class="box-header with-border">
                                    <h3 class="box-title">{{ $t('info') }}</h3>
                                </div>

                                <div class="box-body">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-3">
                                            <strong>{{ $t('name') }}:</strong>
                                            <p>{{ tag.name }}</p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('createdAt') }}:</strong>
                                            <p>
                                                {{ formatDate(tag.createdAt) }}
                                            </p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('updatedAt') }}:</strong>
                                            <p>
                                                {{ formatDate(tag.updatedAt) }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('active') }}:</strong>
                                            <p>
                                                <ValueYesNo :value="tag.active" />
                                            </p>
                                        </div>

                                        <div class="col-xs-12 col-sm-6 col-md-3">
                                            <strong>{{ $t('offer.offers') }}:</strong>
                                            <p>
                                                <ValueListEmpty
                                                    :list="tag.offers"
                                                    block
                                                    href="/offers/"
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import EventBus from '@/event-bus';
import ValueListEmpty from '@/components/subcomponents/ValueListEmpty';
import ValueYesNo from '@/components/subcomponents/ValueYesNo';
import formatsMixin from '@/mixins/formatsMixin';

export default {
    components: {
        ValueListEmpty,
        ValueYesNo,
    },
    mixins: [formatsMixin],
    data() {
        return {
            isError: false,
            isLoaded: false,
            tagId: this.$route.params.id,
            tag: {},
        };
    },
    computed: {
        headTitle() {
            return this.tag.name && `${this.$t('offer.tag.tag')} ${this.tag.name}`;
        },
    },
    created() {
        this.fetchOfferTag();
    },
    methods: {
        async fetchOfferTag() {
            try {
                const {
                    data: { tag },
                } = await axios.get(`/offers/tags/data/${this.tagId}`);

                this.tag = tag;
            } catch (error) {
                this.isError = true;

                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoaded = true;
            }
        },
    },
};
</script>
